var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserInactiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0219727,
    y: 0.194824,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F1F3F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_267_15035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.022 25.1948V23.1948C24.022 22.134 23.6005 21.1165 22.8504 20.3664C22.1003 19.6163 21.0828 19.1948 20.022 19.1948H12.022C10.9611 19.1948 9.94369 19.6163 9.19355 20.3664C8.4434 21.1165 8.02197 22.134 8.02197 23.1948V25.1948",
    fill: "#97999B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.022 15.1948C18.2311 15.1948 20.022 13.404 20.022 11.1948C20.022 8.98569 18.2311 7.19482 16.022 7.19482C13.8128 7.19482 12.022 8.98569 12.022 11.1948C12.022 13.404 13.8128 15.1948 16.022 15.1948Z",
    fill: "#97999B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.022 25.1948V23.1948C24.022 22.134 23.6005 21.1165 22.8504 20.3664C22.1003 19.6163 21.0828 19.1948 20.022 19.1948H12.022C10.9611 19.1948 9.94369 19.6163 9.19355 20.3664C8.4434 21.1165 8.02197 22.134 8.02197 23.1948V25.1948M20.022 11.1948C20.022 13.404 18.2311 15.1948 16.022 15.1948C13.8128 15.1948 12.022 13.404 12.022 11.1948C12.022 8.98569 13.8128 7.19482 16.022 7.19482C18.2311 7.19482 20.022 8.98569 20.022 11.1948Z",
    stroke: "#97999B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.02197 6.19482L26.022 27.1948",
    stroke: "#97999B",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_267_15035"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4.02197 4.19482)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserInactiveIcon);
export default __webpack_public_path__ + "static/media/UserInactiveIcon.54e2592729cde0776b7da4ca41793372.svg";
export { ForwardRef as ReactComponent };